import { useState } from 'react'
import { apiEtapa3 } from '../api'
import Aviso from '../../components/Aviso'
import { competenciaAtual, moeda } from '../../components/format'
import { Campo, Cards } from '../../etapa2/componentes'

function Rubricas({ itens }) {
  return (
    <table>
      <thead><tr><th>Cód.</th><th>Descrição</th><th>Tipo</th><th className="num">Valor</th></tr></thead>
      <tbody>
        {itens.map((r, i) => (
          <tr key={i}><td>{r.codigo}</td><td>{r.descricao}</td><td>{r.tipo.toLowerCase()}</td><td className="num">{moeda(r.valor)}</td></tr>
        ))}
      </tbody>
    </table>
  )
}

function ValeTransporte({ empresaId }) {
  const [f, setF] = useState({ funcionario_id: 'F1', competencia: competenciaAtual(), salario_base: '', gasto_real: '' })
  const [r, setR] = useState(null)
  const [erro, setErro] = useState('')
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value })
  async function calcular() {
    setErro('')
    try {
      setR(await apiEtapa3.valeTransporte({ ...f, empresa_id: empresaId }))
    } catch (e) {
      setErro(e.message)
      setR(null)
    }
  }
  return (
    <>
      <h3>Vale-transporte</h3>
      <div className="grade">
        <Campo rotulo="Matrícula"><input value={f.funcionario_id} onChange={set('funcionario_id')} /></Campo>
        <Campo rotulo="Competência"><input type="month" value={f.competencia} onChange={set('competencia')} /></Campo>
        <Campo rotulo="Salário base contratual"><input type="number" step="0.01" value={f.salario_base} onChange={set('salario_base')} /></Campo>
        <Campo rotulo="Gasto real no mês"><input type="number" step="0.01" value={f.gasto_real} onChange={set('gasto_real')} /></Campo>
      </div>
      <div className="acoes"><button disabled={!empresaId} onClick={calcular}>Calcular VT</button></div>
      <Aviso>{erro}</Aviso>
      {r && (
        <>
          <Cards itens={[
            ['Desconto do funcionário', moeda(r.desconto_funcionario), r.regra_aplicada],
            ['Custeio da empresa', moeda(r.custeio_empresa), 'Isento de encargos'],
            [`Limite de ${r.limite_percentual}%`, moeda(r.limite_valor), `Gasto real ${moeda(r.gasto_real)}`],
          ]} />
          <Rubricas itens={r.rubricas} />
        </>
      )}
    </>
  )
}

function Alimentacao({ empresaId }) {
  const [f, setF] = useState({
    funcionario_id: 'F1', competencia: competenciaAtual(), tipo: 'VR', forma_fornecimento: 'CARTAO', custo_real: '', desconto_solicitado: '', conforme_pat: true,
  })
  const [r, setR] = useState(null)
  const [erro, setErro] = useState('')
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value })
  async function calcular() {
    setErro('')
    try {
      setR(await apiEtapa3.alimentacao({ ...f, empresa_id: empresaId, desconto_solicitado: f.desconto_solicitado || null }))
    } catch (e) {
      setErro(e.message)
      setR(null)
    }
  }
  return (
    <>
      <h3>Vale-refeição / vale-alimentação</h3>
      <div className="grade">
        <Campo rotulo="Matrícula"><input value={f.funcionario_id} onChange={set('funcionario_id')} /></Campo>
        <Campo rotulo="Competência"><input type="month" value={f.competencia} onChange={set('competencia')} /></Campo>
        <Campo rotulo="Benefício">
          <select value={f.tipo} onChange={set('tipo')}><option value="VR">Vale-refeição</option><option value="VA">Vale-alimentação</option></select>
        </Campo>
        <Campo rotulo="Forma de fornecimento">
          <select value={f.forma_fornecimento} onChange={set('forma_fornecimento')}>
            <option value="CARTAO">Cartão</option><option value="TICKET">Ticket</option>
            <option value="REFEICAO_LOCAL">Refeição no local</option><option value="DINHEIRO">Dinheiro</option>
          </select>
        </Campo>
        <Campo rotulo="Custo real do benefício"><input type="number" step="0.01" value={f.custo_real} onChange={set('custo_real')} /></Campo>
        <Campo rotulo="Desconto desejado"><input type="number" step="0.01" value={f.desconto_solicitado} placeholder="teto legal" onChange={set('desconto_solicitado')} /></Campo>
        <label className="check"><input type="checkbox" checked={f.conforme_pat} onChange={set('conforme_pat')} />Fornecimento conforme o PAT</label>
      </div>
      <p className="fundamento">A inscrição da empresa no PAT vem do cadastro eSocial (aba eSocial).</p>
      <div className="acoes"><button disabled={!empresaId} onClick={calcular}>Calcular</button></div>
      <Aviso>{erro}</Aviso>
      {r && (
        <>
          <Cards itens={[
            ['Desconto do funcionário', moeda(r.desconto_funcionario), `Teto de 20%: ${moeda(r.teto_desconto)}`],
            ['Subsídio da empresa', moeda(r.subsidio_empresa)],
            ['Natureza', r.natureza === 'INDENIZATORIA' ? 'Indenizatória' : 'Salarial',
              r.integra_base_inss ? 'Integra INSS, FGTS e IRRF' : `Isento de encargos${r.empresa_inscrita_pat ? ' (PAT)' : ''}`],
          ]} />
          <Rubricas itens={r.rubricas} />
          <ul className="memoria">{r.memoria_calculo.map((m) => <li key={m}>{m}</li>)}</ul>
        </>
      )}
    </>
  )
}

export default function Beneficios({ empresaId }) {
  return (
    <section>
      <h2>Benefícios</h2>
      <ValeTransporte empresaId={empresaId} />
      <Alimentacao empresaId={empresaId} />
    </section>
  )
}
